import { RouterProvider } from 'react-router-dom';
import 'dayjs/locale/zh-cn';
import { ROUTERS } from '@/router/routers.tsx';
import { Suspense } from 'react';

function App() {
    return (
        <Suspense fallback={<div />}>
            <RouterProvider router={ROUTERS}></RouterProvider>
        </Suspense>
    );
}

export default App;
